import Vue from 'vue'

export const setShippingList = (state, param) => {
  state.list = param
}

export const setShippingQuota = (state, param) => {
  state.availableQuota = param
}

export const setShippingPageView = (state, param) => {
  state.shippingPageView = param
}

export const setShippingRegionList = (state, param) => {
  state.regionList = param
}

export const setRegionId = (state, param) => {
  state.region.id = param
}

export const setShippingRegion = (state, param) => {
  state.region = param.data.shipping_region
}

export const setShippingItems = (state, param) => {
  state.shippingItemList = param.data.shipping_items
  state.shippingType = param.data.shipping_type
  state.shippingConfig = param.data.shipping_config
}

export const addNewShippingItemList = (state, param) => {
  state.shippingItemList.push(param)
}

export const updateShippingItemList = (state, param) => {
  if (param.index !== '' && param.index !== undefined) {
    Vue.set(state.shippingItemList, param.index, param)
  }
}

export const setCountry = (state, param) => {
  state.country = param.data.country
}

export const setShippingRegionTypeSort = (state, param) => {
  state.shippingItemList = param
}

export const updateShippingRegionById = (state, param) => {
  state.regionList = state.country.map((shippingRegion, index) => {
    if (shippingRegion.id === param.id) {
      return param
    } else {
      return shippingRegion
    }
  })
}

export const setShippingAllThaiProvinceByRegionId = (state, param) => {
  state.province = param.data
}

export const setShippingProvince = (state, param) => {
  state.shipping_province = param.data.shipping_province
}

export const setShippingThaiProvinceList = (state, param) => {
  state.provinceList = param
}

export const updateShippingProvinceById = (state, param) => {
  state.provinceList = state.provinceList.map((shippingProvince, index) => {
    if (shippingProvince.province_id === param.id) {
      return param
    } else {
      return shippingProvince
    }
  })
}

export const setTabSelected = (state, param) => {
  state.shippingTabSelected = param
}

export const setDeleteShippingItem = (state, param) => {
  state.deleteShippingItemData.push(param)
  state.shippingItemList.splice(param.index, 1)
}

export const setShippingItemStatusIndex = (state, param) => {
  Vue.set(state.shippingItemList[param.index], 'status', param.status)
}



// WEBPACK FOOTER //
// ./src/store/modules/shipping/mutations.js